<template>
  <main class="dashboard">
    <div class="d-flex pt-3 pb-2 mb-3 border-bottom">
      <h1 class="h2">Мониторинг отзывов</h1>
    </div>

    <div class="card" v-if="response">
      <div class="card-header d-flex">
        <div>
          <h4><a :href="response.link" class="break-anyway">{{ response.link }}</a></h4>

          <span class="status ms-auto" v-if="response?.parser?.id && !response.parser?.collect_data">
                      <span class="process"></span>
                      <span>В процессе сбора</span>
                    </span>
          <span class="status" v-else-if="response?.parser?.id">
                      <span>Период: {{
                          $moment(response.parser.date_start).format("DD.MM.YY")
                        }} - {{ $moment(response.parser.date_end).format("DD.MM.YY") }}</span>
                      <span>Дата запуска: {{ $moment(response.parser.date_create).format("DD.MM.YY HH:mm") }}</span>
                    </span>
        </div>

        <router-link active-class="active" class="btn btn-sm ms-auto" title="Назад"
                     :to="{name: 'reviews_monitor'}">
          <b class="h3"><i class="bi bi-x-lg"></i></b>
        </router-link>
      </div>

      <div class="card-body">
        <div class="d-flex flex-column">
                    <span class="text-secondary ms-auto">
                      Количество отзывов:
                      <b class="text-dark badge bg-secondary">{{ response.parser?.review_count }}</b>
                    </span>

        </div>


        <div class="responses">
          <div class="response" v-for="review in responses">
            <div class="header">
              <div class="date-response" v-if="review.date_response">
                <span v-if="review.city">{{ review.city }}, </span>
                {{ $moment(review.date_response).format("DD.MM.YY HH:mm") }}
                <span class="version" v-if="(review.versions-1)>0"> <b> версий</b>: {{ review.versions-1 }}</span>
              </div>

              <div class="rating">
                <div class="badge" v-if="review.tone" :style="{background: $COLORS[review.tone]}">
                  {{ review.get_tone_display }}
                </div>
                <div class="star-rating" :data-rating="review.rating">
                  <div class="stars-container">
                    <svg class="stars-background" viewBox="0 0 100 20">
                      <polygon points="10,2 4,19 19,8 1,8 16,19" fill="lightgray"/>
                      <polygon points="30,2 24,19 39,8 21,8 36,19" fill="lightgray"/>
                      <polygon points="50,2 44,19 59,8 41,8 56,19" fill="lightgray"/>
                      <polygon points="70,2 64,19 79,8 61,8 76,19" fill="lightgray"/>
                      <polygon points="90,2 84,19 99,8 81,8 96,19" fill="lightgray"/>
                    </svg>
                    <div class="stars-foreground" :style="{'--rating': review.rating}">
                      <svg viewBox="0 0 100 20" preserveAspectRatio="none">
                        <polygon points="10,2 4,19 19,8 1,8 16,19" fill="#D59A00"/>
                        <polygon points="30,2 24,19 39,8 21,8 36,19" fill="#D59A00"/>
                        <polygon points="50,2 44,19 59,8 41,8 56,19" fill="#D59A00"/>
                        <polygon points="70,2 64,19 79,8 61,8 76,19" fill="#D59A00"/>
                        <polygon points="90,2 84,19 99,8 81,8 96,19" fill="#D59A00"/>
                      </svg>
                    </div>
                  </div>
                  <span class="rating-value">{{ review.rating }}</span>
                </div>
              </div>
            </div>
            <div class="text d-flex" style="flex-direction: column; gap: 5px">
              <div>
                <p><b>Текст отзыва:</b> {{ review.content?.text }}</p>
              </div>
              <div>
                <p><b>Аспект тональности:</b>
                  <ol class="" v-if="review.thesis" style="font-family: monospace, monospace; font-weight: bold;">
                    <li v-for="thesis in review.thesis?.split('\n')">{{ thesis }}</li>
                  </ol>
                </p>
              </div>


            </div>
            <div class="bottom">
              <div class="tags">
                <div class="badge bg-secondary" v-for="tag in review.tags">
                  {{ tag.name }}
                </div>

              </div>
              <div class="answer-count" @click="review.show_answer=!review.show_answer">Ответов:
                {{ review.content?.responses.length }}
              </div>
            </div>

            <div class="answers" v-show="review.show_answer">

              <div class="answer" v-for="answer in review.content?.responses">
                <div class="date-response" v-if="answer.date">
                  {{ $moment(answer.date).format("DD.MM.YY HH:mm") }}
                </div>
                <div class="text">
                  {{ answer.text }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <PagerList class="mt-3" v-bind:pager="response_pager" v-bind:updatePage="updateResponsePage"
                   v-bind:page="response_page"></PagerList>
      </div>

    </div>


  </main>
</template>

<script>
import {DictionaryApi} from '@/api/dictionary'
import {Line} from "vue-chartjs";
import PagerList from '@/components/includes/PagerList.vue';

export default {
  name: 'ReviewDetail',
  components: {Line, PagerList},
  data() {
    return {
      name: 'reviews_monitor',
      responses: [],
      response: null,
      response_size: 20,
      response_all_count: 0,
      response_page: 1
    }
  },
  computed: {
    response_pager() {
      return this.response_pager = this.$func.getPagerArray(this.response_all_count, this.response_size, this.response_page)
    }
  },
  watch: {
    response_page() {
      if (this.response) this.getResponse()
    }
  },
  mounted() {
    let $this = this;
    DictionaryApi.get(this.name, this.$route.params.id).then(response => {
      $this.response = response;
      $this.getResponse()
    })

  },
  methods: {

    getResponse() {
      let $this = this;

      DictionaryApi.get_list("reviews_monitor_detail", this.response_page, this.response_size, `review_site=${this.$route.params.id}`).then(response => {
        $this.responses = response.results
        $this.response_all_count = response.count;
      })

    },
    updateResponsePage(page) {
      this.response_page = page
    }

  }
}
</script>
<style scoped lang="scss">
.head {
  justify-content: space-between;
}

.status {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 10px;

  .process {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    display: block;
    margin: 0 auto;
    position: relative;
    background: #F0F0F0FF;
    box-shadow: -24px 0 #F0F0F0FF, 24px 0 #F0F0F0FF;
    box-sizing: border-box;
    animation: shadowPulse 2s linear infinite;
  }
}


@keyframes shadowPulse {
  33% {
    background: #F0F0F0FF;
    box-shadow: -24px 0 #87CEFAFF, 24px 0 #F0F0F0FF;
  }
  66% {
    background: #87CEFAFF;
    box-shadow: -24px 0 #F0F0F0FF, 24px 0 #F0F0F0FF;
  }
  100% {
    background: #FFF;
    box-shadow: -24px 0 #F0F0F0FF, 24px 0 #87CEFAFF;
  }
}

.responses {
  display: flex;
  flex-direction: column;
  gap: 20px;

  .response {
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 10px;
    display: flex;
    flex-direction: column;

    .header {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #ccc;
      padding: 3px 0;

      .rating {
        display: flex;
        gap: 10px;
        align-items: center;

        .badge {
          font-size: 10px;
        }

        .star-rating {
          display: inline-flex;
          align-items: center;
          font-size: 16px;

          .stars-container {
            position: relative;
            width: 100px;
            height: 20px;

            .stars-background {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
            }

            .stars-foreground {
              position: absolute;
              top: 0;
              left: 0;
              width: calc(var(--rating) / 5 * 100%);
              height: 100%;
              overflow: hidden;

              svg {
                width: 100px;
                height: 100%;
              }
            }
          }

          .rating-value {
            font-size: 12px;
            margin-left: 5px;
          }
        }


      }


    }

    .date-response {
      font-size: 10px;
    }

    .text {
      margin-top: 5px;
      font-size: 12px;
    }

    .bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .tags {
        display: flex;
        gap: 10px;
      }

      .answer-count {
        font-size: 10px;
        text-align: right;
        margin-left: auto;
        border-bottom: 1px dotted;
        cursor: pointer;
        line-height: 1;
      }
    }


    .answers {
      display: flex;
      flex-direction: column;
      gap: 15px;
      margin-left: 40px;
      margin-top: 15px;

      .answer {
        border-left: 1px solid #ccc;
        padding-left: 15px;
      }
    }

  }
}

.card-header {
  gap: 50px;
}

@media (width < 768px) {
  .card-header {
    flex-direction: column;
    gap: 5px;

    a.btn {
      order: -1;
    }
  }
}

</style>


